"use strict";
exports.__esModule = true;
// export * from './fresh';
var fresh_request_1 = require("./fresh-request");
exports["default"] = fresh_request_1.FreshRequest;
exports.FreshRequest = fresh_request_1.FreshRequest;
//# sourceMappingURL=index.js.map